var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacturasEmitidas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.31982 19.7852V5.28516C3.31982 4.75472 3.52139 4.24602 3.88018 3.87094C4.23897 3.49587 4.72559 3.28516 5.23299 3.28516H16.1381C16.2903 3.28516 16.4363 3.34837 16.5439 3.46089C16.6515 3.57341 16.712 3.72603 16.712 3.88516V21.2852H4.7547M7.14616 7.28516H12.8857M4.7547 15.2852H16.712M4.7547 18.2852H16.712",
    stroke: "#01295F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.712 11.3291H21.9955M21.9955 11.3291L18.9955 8.3291M21.9955 11.3291L18.9955 14.3291",
    stroke: "#01295F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.81982 15.2852C3.81982 15.2852 3.31982 15.9572 3.31982 16.7852C3.31982 17.6132 3.81982 18.2852 4.81982 18.2852C3.81982 18.2852 3.31982 18.9572 3.31982 19.7852C3.31982 20.6132 3.81982 21.2852 4.81982 21.2852",
    stroke: "#01295F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacturasEmitidas);
export default __webpack_public_path__ + "static/media/facturas_emitidas.7a6c8f4a1aef16b622fea59ebc85534e.svg";
export { ForwardRef as ReactComponent };